export const selectSnackbar = () => (state) => state.snackbar;
